import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, Home } from 'lucide-react';
import { Button } from '../components/ui/button';
import ArticleContent from '../components/articles/ArticleContent';
import { mockArticles } from '../data/mock';
import { fullArticles } from '../data/fullArticles';
import SEO, { articleJsonLd, breadcrumbJsonLd } from '../components/SEO';
import { RelatedSimulators, RelatedArticlesForArticle } from '../components/RelatedContent';

const ArticlePage = () => {
  const { slug } = useParams();
  
  // Récupérer l'article avec son contenu complet
  const baseArticle = mockArticles.find(article => article.slug === slug);
  const fullArticle = fullArticles[slug];
  
  if (!baseArticle) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">Article non trouvé</h1>
          <Link to="/articles">
            <Button className="bg-blue-600 hover:bg-blue-700">
              Retour aux articles
            </Button>
          </Link>
        </div>
      </div>
    );
  }

  // Combiner les données de base avec le contenu complet
  const article = {
    ...baseArticle,
    ...fullArticle,
    fullContent: fullArticle?.fullContent || baseArticle.content
  };

  return (
    <div className="min-h-screen bg-white pt-20">
      <SEO
        title={article.title}
        description={article.excerpt}
        path={`/article/${slug}`}
        type="article"
        article={{ date: article.publishedAt, author: article.author || 'Bozzam', tags: article.tags }}
        jsonLd={articleJsonLd(article)}
      />
      {/* Contenu principal */}
      <div className="py-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-6">
            <Link to="/articles">
              <Button variant="outline" size="sm">
                <ArrowLeft className="h-4 w-4 mr-2" />
                Retour aux articles
              </Button>
            </Link>
          </div>
          
          <ArticleContent article={article} />
          
          <RelatedSimulators articleSlug={slug} />
          <RelatedArticlesForArticle articleSlug={slug} />
        </div>
      </div>
    </div>
  );
};

export default ArticlePage;